import React, { useCallback, useEffect, useState } from "react";
import { Button, Modal, ModalActions, ModalContent, ModalTitle, ToastProvider } from '@deere/fuel-react';
import { postDataWAuthFile } from "../../utils/api-service";
import { ROLES, UPLOAD_FILE } from "../../constants/constant";
import CustomFileInputField from "./custom-file-input";
import CustomCountrySelect from "./custom-country-select";
import ToastMessageFunction from "../toast-message-function";
import "./fileUpload.css";
import { useSelector } from "react-redux";
import { checkErrorMsg, getUserRole } from "../../utils/utils";
import { useTranslation } from "../translation-context";

const FileFunction = () => {
  const [ismodalOpen, setIsModalOpen] = useState(false);
  const [fileForUpload, setFileForUpload] = useState();
  const [countryForUpload, setCountryForUpload] = useState();
  const userData = useSelector((state) => state.userState.userData);
  const toastManager = ToastMessageFunction();
  const { translate:t } = useTranslation();

  const showToast = useCallback((message, severity) => {
    toastManager.getToast(message, severity);
  }, [toastManager]);

  const handleOpenModal = () => {
    if (getUserRole(userData) === ROLES.BP) {
      ismodalOpen ? setIsModalOpen(false) : setIsModalOpen(true);
    } else {
      showToast(t("unauthorizedForFileUpload"), "error");
    }
  }

  const handleSelectedCountry = (country) => {
    setCountryForUpload(country);
  }

  const currentUploadedFile = (file) => {
    setFileForUpload(file);
  }

  const handleFileChange = () => {
    let check = countryForUpload+"_";
    if (fileForUpload && countryForUpload && !fileForUpload.name.includes(check)) {

      let countryName;
    switch (countryForUpload) {
      case 'FR':
        countryName = 'France';
        break;
      case 'DE':
        countryName = 'Germany';
        break;
      case 'GB':
        countryName = 'United Kingdom';
        break;
      default:
        countryName = 'Unknown';
    }
    let message = 'Select valid file for the country ' + countryName;   
      showToast(message, 'error');
    } else {
      if (fileForUpload) {
        showToast(t("fileUploading"), 'info');
        const formData = new FormData();
        formData.append('file', fileForUpload);

        postDataWAuthFile(UPLOAD_FILE, fileForUpload)
          .then((res) => {
            if (res.status === 200) {
              showToast(t("fileUploadSuccess"), 'success');
            } else {
              showToast(t("fileUploadFail"), 'error');
            }
          })
          .catch((error) => {
            if (checkErrorMsg(error)) showToast(checkErrorMsg(error), "error");
            else showToast(t("fileUploadFail"), 'error');
          });
        setIsModalOpen(false);
      }
    }
  };

  useEffect(() => {}, [fileForUpload, countryForUpload]);

  return (
    <div>
      {toastManager.toast}
      <div className="button" >
        <a href={`${process.env.PUBLIC_URL}/Bank_Finance_File_Template.xlsx`} download="Bank_Finance_File_Template.xlsx" style={{ marginRight: "10px" }}>
          <Button variant="secondary" >Download Bank Data Template</Button>
        </a>
        <Button variant="primary" onClick={handleOpenModal}>Upload Bank Data</Button>
      </div>
      <div>
        <Modal className="modal" open={ismodalOpen} onClose={handleOpenModal}>
          <ModalTitle className="modalTitle">File Upload</ModalTitle>
          <ModalContent className="modalContent">
            <CustomCountrySelect selectedCountry={handleSelectedCountry} />
            <ToastProvider>
              <CustomFileInputField uploadFile={currentUploadedFile} />
            </ToastProvider>
          </ModalContent>
          <ModalActions className="modalActions">
            <Button className="modalButton" variant="secondary" onClick={handleOpenModal}>
              Cancel
            </Button>
            <Button className="modalButton" variant="primary" onClick={handleFileChange}>
              Upload
            </Button>
          </ModalActions>
        </Modal>
      </div>
    </div>
  );
};


export default FileFunction;